import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Label } from '@/new/components/shadcn/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/new/components/shadcn/select';
import { FilterOption } from '@/types';

const baseSortFieldOptions: FilterOption[] = [
  { label: 'Document Date', value: 'date' },
  { label: 'Upload Date', value: 'createdDate' },
  { label: 'Filename', value: 'name' },
  { label: 'Author', value: 'author' },
  { label: 'Type', value: 'type' },
  { label: 'Facts Count', value: 'factsCount' },
];

const sortOrderOptions: FilterOption[] = [
  { label: 'Descending', value: 'DESC' },
  { label: 'Ascending', value: 'ASC' },
];

export const DocSortPopup = ({
  activeSortBy,
  activeSortOrder,
  setSortBy,
  setSortOrder,
  hasActiveSearch,
}: {
  activeSortBy: string;
  activeSortOrder: 'ASC' | 'DESC';
  setSortBy: (value: string) => void;
  setSortOrder: (value: 'ASC' | 'DESC') => void;
  hasActiveSearch?: boolean;
}) => {
  // Add chunkMatchCount option when there's an active search
  const sortFieldOptions = hasActiveSearch
    ? [...baseSortFieldOptions, { label: 'Matches in Content', value: 'chunkMatchCount' }]
    : baseSortFieldOptions;

  return (
    <>
      {/* Sort Field */}
      <div>
        <Label className="mb-2 block">Sort By</Label>
        <Select
          value={activeSortBy}
          onValueChange={(newValue) => {
            if (newValue) {
              trackCustomEvent(TrackingEventsV2.ApplySortOnDocumentsPage);
              setSortBy(newValue);
            }
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select sort field..." />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {sortFieldOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>

      {/* Sort Order - only show if a sort field is selected */}
      {activeSortBy && (
        <div>
          <Label className="mb-2 block">Sort Order</Label>
          <Select
            value={activeSortOrder}
            onValueChange={(newValue) => {
              if (newValue) {
                trackCustomEvent(TrackingEventsV2.ApplySortOnDocumentsPage);
                setSortOrder(newValue as 'ASC' | 'DESC');
              }
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select sort order..." />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {sortOrderOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      )}
    </>
  );
};
